export const CLOSE_DROPDOWN_EVENT = 'Close Search Dropdown';

// Fixed string from @cognitedata/react-picture-annotations
export const SIDEBAR_RESIZE_EVENT = 'resize';
